import { render, staticRenderFns } from "./TierDialog.vue?vue&type=template&id=04a801d8&scoped=true"
import script from "./TierDialog.vue?vue&type=script&lang=js"
export * from "./TierDialog.vue?vue&type=script&lang=js"
import style0 from "./TierDialog.vue?vue&type=style&index=0&id=04a801d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a801d8",
  null
  
)

export default component.exports